<template>
  <div class="text-center">
    <b-row no-gutters align-v="center" align-h="center">
      <b-col cols="12" align-self="center" class="p-3 bg-warning-light font-weight-bold">
        <b-link :to="{ name: 'TagsForPet', params: { petId: pet.id }, query: { 'side-basket': true } }" class="text-secondary">
          <u>{{ $t('petFooter.chooseTagForNextPet', { petName: pet.name }) }}</u>
        </b-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    pet: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.bg-warning-light {
  background-color: $dp-light-yellow;
}
</style>
